import React from 'react';
import Icon from '../../components/AppIcon';
import { Link } from 'react-router-dom';
import TopNavigation from '../../components/TopNavigation';
import Footer from '../../components/Footer';

const AutomotiveRemoteHardwareFarmUseCaseDetail = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <TopNavigation />
      
      {/* Hero Section */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      
      {/* Left Column - Text Content */}
      <div>
        <div 
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold uppercase tracking-wider mb-6 w-fit"
          style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)', border: '1px solid rgba(245, 203, 92, 0.4)', color: '#F5CB5C' }}
        >
          Automotive SDV Development
        </div>
        
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" style={{ color: '#E8EDDF' }}>
          Access Any<br />Hardware,<br /><span style={{ fontStyle: 'italic' }}>Anywhere</span>
        </h1>
        
        <p className="text-base md:text-lg leading-relaxed mb-8" style={{ color: '#9CA3AF' }}>
          Browser-based development, testing, and deployment unified across physical HIL hardware and virtual device farms. No local setup. No hardware queues. Instant access.
        </p>
        
        <div className="flex flex-wrap gap-4">
          <Link 
            to="/contact" 
            className="inline-flex items-center gap-2 px-8 py-4 rounded-lg font-semibold text-base transition-colors"
            style={{ backgroundColor: '#4FB3B8', color: '#242423' }}
          >
            Book a Demo
          </Link>
          <Link 
            to="/product" 
            className="inline-flex items-center gap-2 px-8 py-4 rounded-lg font-semibold text-base transition-colors"
            style={{ backgroundColor: 'transparent', border: '2px solid #F5CB5C', color: '#F5CB5C' }}
          >
            Explore Features
          </Link>
        </div>
      </div>
      
      {/* Right Column - Browser Mockup */}
      <div className="flex items-center justify-center">
        <div 
          className="w-full rounded-xl overflow-hidden"
          style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
        >
          {/* Browser Chrome */}
          <div className="flex items-center gap-3 px-4 py-3" style={{ borderBottom: '1px solid #3A3A38' }}>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></div>
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#F5CB5C' }}></div>
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#9CA3AF' }}></div>
            </div>
            <span className="text-xs" style={{ color: '#9CA3AF' }}>sleeve.dev/workspace</span>
          </div>
          
          {/* Browser Content */}
          <div className="p-5">
            
            {/* Browser-Based Workspace Header */}
            <div className="flex items-center gap-2 mb-4">
              <span style={{ color: '#4FB3B8' }}>&gt;_</span>
              <span className="text-xs font-bold uppercase tracking-wider" style={{ color: '#4FB3B8' }}>Browser-Based Workspace</span>
            </div>
            
            {/* Code Block */}
            <div 
              className="rounded-lg p-4 mb-5 font-mono text-sm"
              style={{ backgroundColor: '#242423' }}
            >
              <div className="flex items-start gap-2 mb-1">
                <span style={{ color: '#F5CB5C' }}>$</span>
                <span style={{ color: '#E8EDDF' }}>flash --target ecu-01</span>
              </div>
              <div style={{ color: '#9CA3AF' }}># Flashing ECU via HIL rig...</div>
              <div className="flex items-center gap-2">
                <span style={{ color: '#4ADE80' }}>✓</span>
                <span style={{ color: '#E8EDDF' }}>Flash complete: 2.3s</span>
              </div>
            </div>
            
            {/* Physical HIL and Virtual Farm */}
            <div className="grid grid-cols-2 gap-4 mb-4">
              
              {/* Physical HIL */}
              <div 
                className="rounded-lg p-4"
                style={{ backgroundColor: '#242423', border: '1px solid #3A3A38' }}
              >
                <div className="flex items-center gap-2 mb-3">
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
                    <circle cx="12" cy="12" r="3" />
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82-.33l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                  </svg>
                  <span className="text-xs font-bold uppercase" style={{ color: '#E8EDDF' }}>Physical HIL</span>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-xs" style={{ color: '#9CA3AF' }}>ECU-01</span>
                    <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs" style={{ color: '#9CA3AF' }}>ECU-02</span>
                    <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs" style={{ color: '#9CA3AF' }}>ECU-03</span>
                    <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#9CA3AF' }}></span>
                  </div>
                </div>
              </div>
              
              {/* Virtual Farm */}
              <div 
                className="rounded-lg p-4"
                style={{ backgroundColor: '#242423', border: '1px solid #3A3A38' }}
              >
                <div className="flex items-center gap-2 mb-3">
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
                    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
                  </svg>
                  <span className="text-xs font-bold uppercase" style={{ color: '#E8EDDF' }}>Virtual Farm</span>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-xs" style={{ color: '#9CA3AF' }}>SIM-01</span>
                    <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs" style={{ color: '#9CA3AF' }}>SIM-02</span>
                    <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#F5CB5C' }}></span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs" style={{ color: '#9CA3AF' }}>SIM-03</span>
                    <span className="w-2 h-2 rounded-full" style={{ backgroundColor: '#F5CB5C' }}></span>
                  </div>
                </div>
              </div>
              
            </div>
            
            {/* Footer Text */}
            <p className="text-xs text-center" style={{ color: '#9CA3AF' }}>
              Unified abstraction layer • Instant provisioning • Browser-based access
            </p>
            
          </div>
        </div>
      </div>
      
    </div>
  </div>
</section>

      {/* Problem Section */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        The Problem: Hardware Bottlenecks in SDV Development
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Physical hardware limitations create friction across the entire development lifecycle.
      </p>
    </div>
    
    {/* Three Cards */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      
      {/* Access Conflicts */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '2px dashed #FF6B6B' }}
      >
        {/* Icon */}
        <div 
          className="w-14 h-14 rounded-xl flex items-center justify-center mb-6"
          style={{ backgroundColor: 'rgba(255, 107, 107, 0.15)' }}
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        
        <h3 className="text-xl md:text-2xl font-bold mb-5" style={{ color: '#E8EDDF' }}>
          Access Conflicts
        </h3>
        
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Scarce HIL rigs create bottlenecks</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Engineers queue for hours or days</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Integration tests skipped under pressure</span>
          </li>
        </ul>
      </div>
      
      {/* Distributed Teams */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '2px dashed #FF6B6B' }}
      >
        {/* Icon */}
        <div 
          className="w-14 h-14 rounded-xl flex items-center justify-center mb-6"
          style={{ backgroundColor: 'rgba(255, 107, 107, 0.15)' }}
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
            <circle cx="9" cy="7" r="3" />
            <circle cx="15" cy="7" r="3" />
            <path d="M3 18c0-3 3-5 6-5" />
            <path d="M15 13c3 0 6 2 6 5" />
            <path d="M12 13v5" />
          </svg>
        </div>
        
        <h3 className="text-xl md:text-2xl font-bold mb-5" style={{ color: '#E8EDDF' }}>
          Distributed Teams
        </h3>
        
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Global engineering teams need access</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Secure remote access is complex</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>High coordination overhead</span>
          </li>
        </ul>
      </div>
      
      {/* Environment Mismatch */}
      <div 
        className="rounded-xl p-6"
        style={{ backgroundColor: '#2E2E2C', border: '2px dashed #FF6B6B' }}
      >
        {/* Icon */}
        <div 
          className="w-14 h-14 rounded-xl flex items-center justify-center mb-6"
          style={{ backgroundColor: 'rgba(255, 107, 107, 0.15)' }}
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
            <polygon points="12 2 2 7 12 12 22 7 12 2" />
            <polyline points="2 17 12 22 22 17" />
            <polyline points="2 12 12 17 22 12" />
          </svg>
        </div>
        
        <h3 className="text-xl md:text-2xl font-bold mb-5" style={{ color: '#E8EDDF' }}>
          Environment Mismatch
        </h3>
        
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Local development ≠ HIL environment</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Long onboarding for new engineers</span>
          </li>
          <li className="flex items-start gap-3">
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
              style={{ border: '1.5px solid #FF6B6B' }}
            >
              <span style={{ color: '#FF6B6B', fontSize: '12px', fontWeight: '600' }}>!</span>
            </div>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Rework and integration delays</span>
          </li>
        </ul>
      </div>
      
    </div>
    
  </div>
</section>

      {/* Sleeve Solution Section */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Sleeve: The Centralized SDV Development Hub
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Bridge cloud-native development workflows with physical automotive hardware through a unified, browser-based platform.
      </p>
    </div>
    
    {/* 2x2 Grid of Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      
      {/* Universal Remote Access */}
      <div 
        className="rounded-xl p-6 md:p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(79, 179, 184, 0.15)', border: '1px solid rgba(79, 179, 184, 0.3)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
          </div>
          <h3 className="text-xl md:text-2xl font-bold pt-2" style={{ color: '#4FB3B8' }}>
            Universal Remote Access
          </h3>
        </div>
        
        <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
          Access physical HIL rigs, ECUs, and virtual simulators through a single interface. No VPN setup. No local toolchain configuration. Unified abstraction treats physical and virtual devices identically.
        </p>
        
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#4FB3B8' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Physical HIL rigs (Lauterbach, Vector, ETAS)</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#4FB3B8' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Virtual device farms and simulators</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#4FB3B8' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Prototype vehicles with onboard connectivity</span>
          </li>
        </ul>
      </div>
      
      {/* Instant Browser-Based Workspaces */}
      <div 
        className="rounded-xl p-6 md:p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)', border: '1px solid rgba(245, 203, 92, 0.3)' }}
          >
            <span className="text-base font-mono font-bold" style={{ color: '#F5CB5C' }}>&gt;_</span>
          </div>
          <h3 className="text-xl md:text-2xl font-bold pt-2" style={{ color: '#F5CB5C' }}>
            Instant Browser-Based Workspaces
          </h3>
        </div>
        
        <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
          Full development environment in the browser. Eclipse Theia IDE, terminal access, debugging tools, and automotive toolchains pre-configured. Zero local setup required. Engineers productive from day one.
        </p>
        
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#F5CB5C' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Cloud-native IDE with code completion</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#F5CB5C' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Integrated terminal and debugging</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#F5CB5C' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Pre-configured automotive toolchains</span>
          </li>
        </ul>
      </div>
      
      {/* Intelligent Virtual Farm Management */}
      <div 
        className="rounded-xl p-6 md:p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)', border: '1px solid rgba(245, 203, 92, 0.3)' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </svg>
          </div>
          <h3 className="text-xl md:text-2xl font-bold pt-2" style={{ color: '#F5CB5C' }}>
            Intelligent Virtual Farm Management
          </h3>
        </div>
        
        <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
          Automatically provision virtual ECUs and simulators when physical hardware is unavailable. Seamless overflow from physical HIL to virtual replicas. Identical test execution across both environments with artifact capture.
        </p>
        
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#F5CB5C' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Auto-provision virtual targets on demand</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#F5CB5C' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Queue overflow to simulators automatically</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#F5CB5C' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Parallel test execution across targets</span>
          </li>
        </ul>
      </div>
      
      {/* Seamless Dev → Test → Deploy Consistency */}
      <div 
        className="rounded-xl p-6 md:p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <div className="flex items-start gap-4 mb-4">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: 'rgba(156, 163, 175, 0.15)', border: '1px solid rgba(156, 163, 175, 0.3)' }}
          >
            <span className="text-base font-mono font-bold" style={{ color: '#9CA3AF' }}>&lt;&gt;</span>
          </div>
          <h3 className="text-xl md:text-2xl font-bold pt-2" style={{ color: '#9CA3AF' }}>
            Seamless Dev → Test → Deploy Consistency
          </h3>
        </div>
        
        <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
          Same environment from laptop to CI/CD to production HIL. Infrastructure-as-code for reproducible configurations. Eliminate "works on my machine" issues with containerized, version-controlled toolchains.
        </p>
        
        <ul className="space-y-3">
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#9CA3AF' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Identical dev and test environments</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#9CA3AF' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>CI/CD integration with hardware targets</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#9CA3AF' }}></span>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Version-controlled toolchain configurations</span>
          </li>
        </ul>
      </div>
      
    </div>
    
  </div>
</section>

      {/* How It Works Section */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        How It Works
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        A deterministic, reproducible workflow for SDV development and testing.
      </p>
    </div>
    
    {/* Three Step Cards with Arrows */}
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-stretch">
      
      {/* Step 1 - Connect & Abstract */}
      <div className="relative">
        <div 
          className="rounded-xl p-6 h-full"
          style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
        >
          <div 
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold uppercase tracking-wider mb-4"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)', border: '1px solid rgba(245, 203, 92, 0.4)', color: '#F5CB5C' }}
          >
            Step 1
          </div>
          
          <h3 className="text-xl md:text-2xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
            Connect & Abstract
          </h3>
          
          <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
            Hardware and virtual devices registered with Sleeve. Unified abstraction layer provides consistent interface regardless of physical or virtual target.
          </p>
          
          {/* Device List */}
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm font-mono" style={{ color: '#9CA3AF' }}>HIL-Rack-01</span>
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm font-mono" style={{ color: '#9CA3AF' }}>HIL-Rack-02</span>
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm font-mono" style={{ color: '#9CA3AF' }}>Virtual-Farm</span>
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
          </div>
        </div>
        
        {/* Arrow - visible on lg screens */}
        <div className="hidden lg:flex absolute -right-4 top-1/2 transform -translate-y-1/2 z-10">
          <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
            <path d="M5 12h14M13 5l7 7-7 7"/>
          </svg>
        </div>
      </div>
      
      {/* Step 2 - Launch Workspace */}
      <div className="relative">
        <div 
          className="rounded-xl p-6 h-full"
          style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
        >
          <div 
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold uppercase tracking-wider mb-4"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)', border: '1px solid rgba(245, 203, 92, 0.4)', color: '#F5CB5C' }}
          >
            Step 2
          </div>
          
          <h3 className="text-xl md:text-2xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
            Launch Workspace
          </h3>
          
          <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
            Browser-based workspace provisions instantly with pre-configured toolchains. Select target hardware or simulator. Begin development immediately.
          </p>
          
          {/* Code Block */}
          <div 
            className="rounded-lg p-4"
            style={{ backgroundColor: '#242423', border: '1px solid #3A3A38' }}
          >
            {/* Browser dots */}
            <div className="flex items-center gap-1.5 mb-3">
              <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></div>
              <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#F5CB5C' }}></div>
              <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: '#9CA3AF' }}></div>
            </div>
            
            <div className="space-y-2 font-mono text-xs">
              <div>
                <span style={{ color: '#9CA3AF' }}>workspace: </span>
                <span style={{ color: '#4ADE80' }}>ready</span>
              </div>
              <div>
                <span style={{ color: '#9CA3AF' }}>target: </span>
                <span style={{ color: '#E8EDDF' }}>HIL-Rack-01</span>
              </div>
              <div>
                <span style={{ color: '#9CA3AF' }}>toolchain: </span>
                <span style={{ color: '#E8EDDF' }}>loaded</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Arrow - visible on lg screens */}
        <div className="hidden lg:flex absolute -right-4 top-1/2 transform -translate-y-1/2 z-10">
          <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
            <path d="M5 12h14M13 5l7 7-7 7"/>
          </svg>
        </div>
      </div>
      
      {/* Step 3 - Develop, Test, Release */}
      <div>
        <div 
          className="rounded-xl p-6 h-full"
          style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
        >
          <div 
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-xs font-semibold uppercase tracking-wider mb-4"
            style={{ backgroundColor: 'rgba(245, 203, 92, 0.15)', border: '1px solid rgba(245, 203, 92, 0.4)', color: '#F5CB5C' }}
          >
            Step 3
          </div>
          
          <h3 className="text-xl md:text-2xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
            Develop, Test, Release
          </h3>
          
          <p className="text-sm leading-relaxed mb-6" style={{ color: '#9CA3AF' }}>
            Write code, flash ECUs, run automated tests, and deploy—all from the browser. Consistent environment from development through CI/CD to production.
          </p>
          
          {/* Status List */}
          <div className="space-y-2 font-mono text-xs">
            <div className="flex items-center gap-2">
              <span style={{ color: '#4ADE80' }}>✓</span>
              <span style={{ color: '#4FB3B8' }}>Build complete</span>
            </div>
            <div className="flex items-center gap-2">
              <span style={{ color: '#4ADE80' }}>✓</span>
              <span style={{ color: '#4FB3B8' }}>Flashed to ECU</span>
            </div>
            <div className="flex items-center gap-2">
              <span style={{ color: '#4ADE80' }}>✓</span>
              <span style={{ color: '#4FB3B8' }}>Tests passed (34/34)</span>
            </div>
            <div className="flex items-center gap-2 mt-3">
              <span style={{ color: '#F5CB5C' }}>→</span>
              <span style={{ color: '#F5CB5C' }}>Ready for release</span>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    
  </div>
</section>

      {/* Integrated Automotive Toolchains Section */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Integrated Automotive Toolchains
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Sleeve integrates with industry-standard automotive development and debugging tools, plus modern open-source workflows.
      </p>
    </div>
    
    {/* Two Cards */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      
      {/* Partner & Industry Tooling */}
      <div 
        className="rounded-xl p-6 md:p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <h3 className="text-xl md:text-2xl font-bold mb-2" style={{ color: '#4FB3B8' }}>
          Partner & Industry Tooling
        </h3>
        <p className="text-sm mb-6" style={{ color: '#9CA3AF' }}>
          Industry-standard automotive debugging, calibration, and diagnostic tools.
        </p>
        
        <div className="space-y-5">
          {/* Lauterbach TRACE32 */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>Lauterbach TRACE32</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>Hardware debugging & trace</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          
          {/* Vector CANoe */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>Vector CANoe</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>Network simulation & testing</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          
          {/* Vector DaVinci */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>Vector DaVinci</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>Configuration & development</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          
          {/* ETAS INCA */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>ETAS INCA</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>ECU calibration & measurement</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          
          {/* Infineon TAS / MemTool */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>Infineon TAS / MemTool</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>Flash programming & calibration</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          
          {/* NXP GoldIP */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>NXP GoldIP</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>MCU software development</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
        </div>
      </div>
      
      {/* Modern Development Tools */}
      <div 
        className="rounded-xl p-6 md:p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <h3 className="text-xl md:text-2xl font-bold mb-2" style={{ color: '#F5CB5C' }}>
          Modern Development Tools
        </h3>
        <p className="text-sm mb-6" style={{ color: '#9CA3AF' }}>
          Open-source tooling and cloud-native development environments.
        </p>
        
        <div className="space-y-5">
          {/* Open-Source Toolchains */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>Open-Source Toolchains</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>GCC, LLVM, GDB, OpenOCD</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          
          {/* Eclipse IDE */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>Eclipse IDE</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>Traditional desktop IDE</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          
          {/* EclipseTheia */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>Eclipse Theia</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>Cloud-native browser IDE</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          
          {/* AI Coding Assistants */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>AI Coding Assistants</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>GitHub Copilot, Codeium</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          
          {/* Git & Version Control */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>Git & Version Control</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>Built-in Git integration</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          
          {/* CI/CD Integration */}
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm font-semibold" style={{ color: '#E8EDDF' }}>CI/CD Integration</div>
              <div className="text-xs" style={{ color: '#9CA3AF' }}>Jenkins, GitLab, GitHub Actions</div>
            </div>
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
        </div>
      </div>
      
    </div>
    
  </div>
</section>
      {/* Custom & In-House Tool Integration Section */}
<section className="py-16 md:py-24 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
      
      {/* Left Column - Title and Description */}
      <div>
        <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
          Custom & In-House Tool Integration
        </h2>
        
        <p className="text-sm md:text-base leading-relaxed" style={{ color: '#9CA3AF' }}>
          Sleeve supports custom integrations for proprietary and in-house automotive tooling. Engineers can build integrations using our documentation, or the Sleeve team can deliver integrations on request.
        </p>
      </div>
      
      {/* Right Column - Integration Options */}
      <div className="space-y-5">
        
        {/* Self-Service Integration */}
        <div className="flex items-start gap-4">
          <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
          <div>
            <div className="text-sm font-semibold mb-1" style={{ color: '#E8EDDF' }}>Self-Service Integration</div>
            <div className="text-sm" style={{ color: '#9CA3AF' }}>Build custom integrations via API documentation</div>
          </div>
        </div>
        
        {/* Sleeve-Delivered Integration */}
        <div className="flex items-start gap-4">
          <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
          <div>
            <div className="text-sm font-semibold mb-1" style={{ color: '#E8EDDF' }}>Sleeve-Delivered Integration</div>
            <div className="text-sm" style={{ color: '#9CA3AF' }}>Request integrations from the Sleeve engineering team</div>
          </div>
        </div>
        
        {/* Proprietary Tool Support */}
        <div className="flex items-start gap-4">
          <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
          <div>
            <div className="text-sm font-semibold mb-1" style={{ color: '#E8EDDF' }}>Proprietary Tool Support</div>
            <div className="text-sm" style={{ color: '#9CA3AF' }}>Integrate in-house automotive development tools</div>
          </div>
        </div>
        
      </div>
      
    </div>
  </div>
</section>

      {/* Final CTA Section */}
      <section className="py-24 md:py-32 px-4 md:px-6 lg:px-8 border-b border-border">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-foreground mb-6">
            Request Your Personalized Demo
          </h2>
          
          <div className="flex flex-wrap justify-center gap-6 mb-8">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Zap" size={16} color="var(--color-primary)" />
              <span>Faster SDV iteration</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Clock" size={16} color="var(--color-primary)" />
              <span>No hardware waiting</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="CheckCircle" size={16} color="var(--color-primary)" />
              <span>Consistent environments</span>
            </div>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/contact" 
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors text-lg"
            >
              Book Your Demo
              <Icon name="ArrowRight" size={18} />
            </Link>
            <Link 
              to="/use-cases/automotive-fleet-management" 
              className="inline-flex items-center gap-2 px-8 py-4 bg-card border border-border text-foreground rounded-lg font-medium hover:bg-card/80 transition-colors text-lg"
            >
              View Fleet Management Use Case
              <Icon name="ArrowRight" size={18} />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AutomotiveRemoteHardwareFarmUseCaseDetail;